import React from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="bg-warm-white py-20 md:py-28" data-id="element-104">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-106">
          <p className="text-xl md:text-2xl lg:text-3xl text-charcoal leading-relaxed" data-id="element-107">
            ¿Te has despertado alguna vez a las 3 de la mañana con un calor
            inexplicable, solo para mirarte al espejo a la mañana siguiente y
            sentir que tu cara y tu abdomen pertenecen a otra persona?
          </p>
          <p className="text-xl md:text-2xl lg:text-3xl text-charcoal leading-relaxed mt-8" data-id="element-108">
            <strong data-id="element-109">No estás sola.</strong> Y lo más importante:{' '}
            <strong data-id="element-110">no es tu culpa.</strong>
          </p>
          <p className="text-xl md:text-2xl lg:text-3xl text-charcoal leading-relaxed mt-8" data-id="element-111">
            Lo que estás experimentando no es falta de voluntad; es un{' '}
            <span className="italic font-serif text-gold" data-id="element-112">
              "secuestro hormonal"
            </span>{' '}
            que ninguna dieta convencional puede solucionar.
          </p>
        </motion.div>
      </div>
    </section>;
}